// Constants
export const BOARD_PADDING_GRID_POINTS = 4;

/**
 * Gets the toolbar bounding rect as it is responsively sized.
 */
export const getToolbarBoundingRect = () => {
    const toolbarDomNode = document.querySelector('.Toolbar');
    return toolbarDomNode ? toolbarDomNode.getBoundingClientRect() : null;
};

/**
 * Removes all CanvasElement layers by removing the transform CSS property from them.
 * This will improve the performance of GPU accelerated Canvas animations as the layer compositing
 * will be much simpler.
 */
export const flattenCanvasLayers = () => {
    const canvasElementNodes = document.querySelectorAll('.CanvasElement');
    const canvasElements = Array.from(canvasElementNodes);
    canvasElements.forEach((el) => {
        el.style.transform = 'none';
    });
};

/**
 * Returns the CanvasElements to their layers.
 */
export const unflattenCanvasLayers = () => {
    const canvasElementNodes = document.querySelectorAll('.CanvasElement');
    const canvasElements = Array.from(canvasElementNodes);
    canvasElements.forEach((el) => {
        el.style.transform = null;
    });
};
